(function (app) {
    app.constant("trainingConstant", {
        GeneralTraining: [
            {
                Title: "NAIC Annuity Training",
                Description: "One-time training required before you write that first piece of annuity business. ", //Failure to complete the required training will result in significant delays which often includes newly signed paperwork.
                Link: "https://www.training.figmarketing.com/post/naic-annuity-suitability",
                ImageUrl: null
            },
            {
                Title: "Anti-Money Laundering",
                Description: "Familiarize yourself with all things money laundering and the trainings required. ", //Each carrier requires all advisors to complete an Anti- Money Laundering training course every two years.
                Link: "https://www.training.figmarketing.com/post/anti-money-laundering",
                ImageUrl: null
            },
            {
                Title: "Long Term Care Training",
                Description: "Initial and ongoing LTC training to keep you ahead of the game. ", //Failure to complete the required training will result in significant delays which often includes newly signed paperwork.
                Link: "https://www.training.figmarketing.com/post/long-term-care-training",
                ImageUrl: null
            },
            {
                Title: "New York - Reg. 187 Training",
                Description: "New regulations, new training. Stay up-to-date on NY Best Interest training.", // Failure to complete the required training will result in significant delays which often includes newly signed paperwork.
                Link: "https://www.training.figmarketing.com/post/new-york-reg-187-training",
                ImageUrl: null
            },
        ]
    });
})(window.app); // jshint ignore:line